import React, { useState, MouseEvent } from 'react';
import { IconButton, Menu, Tooltip } from '@mui/material';
import { FiMoreVertical } from 'react-icons/fi';

const ActionMenu: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Actions">
                <IconButton onClick={handleClick}>
                    <FiMoreVertical size={20} />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {children}
            </Menu>
        </>
    );
};

export default ActionMenu;
